<template >
  <div class="bw">
    <div class="outcard">
      <h2>
        <span v-if="!mbUnit">搜寻对话</span>
        <Input
          v-model="searchtext"
          search
          enter-button
          suffix="ios-search"
          class='searchInput pc'
          placeholder="请输入对话内容"
          @on-keyup="keyup"
          @on-search="search(searchtext)"
        />&nbsp;
        <span @click="searchtext='';modal=false" class="searchClose"><Icon type="md-close"/></span>
      </h2>
      <div class="cardin searchDlog">
        <div class="searchListBlock mb-10" v-for="(item,index) in searchDlogArr" :key="index" @click="searchConfirm(item.index)">
          <div v-if="!regex(item.i.innertext)">
            <Row>
              <Col span="18" class="text" >
                <h3> {{item.i.nickname}} </h3>
                <div v-html="replace(item.i.innertext)" ></div>
              </Col>
              <Col span="6" class="time" >
                <p> {{item.i.time.substring(0,10)}} </p>
              </Col>
            </Row>
          </div>
        </div>
        <div class="searchListBlock mb-10" v-if="searchDlogArr.length < 1"> 无搜寻结果 </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import dialogSearchMixins from '../mixins/dialogSearchMixins'
export default {
  name: "memberDlogSearch",
  mixins:[dialogSearchMixins],
  props: {
    searchStatus: Boolean,
    chatlist: Array,
    searchval: String,
  },
  data () {
    return {
      searchDlogArr: [],
    }
  },
  computed: {
    ...mapGetters(['mbUnit']),
    modal: {
      get () {
        return this.searchStatus
      },
      set (val) {
        this.$emit("update:searchStatus", val)
      }
    },
    searchtext: {
      get () {
        return this.searchval
      },
      set (val) {
        this.$emit("update:searchval",val)
      }
    }
  },
  methods: {
    searchConfirm (val) {
      this.$emit("getSearchMsg", val)
    },
  }
}
</script>
<style lang="less">
.cardin.searchDlog {
  height: 707px;
  overflow-y: auto;
  padding-top: 0;
}
.searchListBlock {
  cursor: pointer;
  border: none;
  border-bottom: solid 1px var(--border-black);
  margin: -1px -20px 0px -20px;
  padding: 20px;
  .text {
    h3 {
      margin-bottom: 4px;
      font-size: 15px;
    }
    div {
      font-size: 12px;
      white-space: inherit;
      .searchText {
        color: var(--main-red);
      }
    }
  }
  .time {
    color: var(--content-black);
    transform: translateY(50%);
  }
}
.searchClose {
  cursor: pointer;
  position: absolute;
  padding: 5px 10px;
  border-radius: 4px;
  right: 0px;
  top: 0px;
  .ivu-icon-md-close{
    color: #fff;
    font-size: 32px;
  }
}
.searchInput {
  position: absolute;
  top: 50%;
  
  width: 60%;
  transform: translateY(-50%);
  .ivu-input {
    border-radius: 4px;
  }
  .ivu-input-group-append {
    &.ivu-input-search {
      display: none;
    }
  }
  .ivu-input-suffix {
    z-index: 9;
  }
  &.pc {
    left: 25%;
  }
}
@media screen and (max-width: 1700px){
  .searchInput.pc {
    width: 55%;
    left: 30%;
  }
}
@media screen and (max-width: 1350px){
  .searchInput.pc {
    width: 50%;
    left: 34%;
  }
}
</style>